import React from 'react';
import PrimaryButton from '../../../component/button/PrimaryButton';
import useCompanyProfile from './company-profile.hooks';
import DetailProfile from './detail-profile';
import {t} from 'i18next';
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import {ActiveDotIcon, CloseIcon, InactiveDotIcon} from '../../../asset';
import {Timeline} from 'antd';
import ManagementHistory from "../../../component/management-history/management-history";
import HeaderManagementHistory from "../../../component/header-management-history/header-management-history";


const DetailCompanyProfile = () => {
    const {
        data,
        tab1,
        tab2,
        tab3,
        onChangeTab,
        setUserManagementOpen,
        userManagementOpen,
        convertTimestamp,
        convertToTime,
        doGetManagementHistoryList,
        managementHistoryList,
        setOperationalDateData,
        operationalDate,
        _toEdit
    } = useCompanyProfile();

    return (
        <>
            <div className=' p-5 h-fit'>
                <Breadcumbs
                    jmlLevel={3}
                    menuLevel1={`Setup`}
                    menuLevel2={`Profile Configuration`}
                    menuLevel3={`Company Profile`}
                />

                <div className='flex items-center justify-between my-[31px]'>
                    <div className="flex items-center gap-[22px]">
                        <h1 className='font-sans-bold text-2xl' id='title'>{`Company Profile`}</h1>
                    </div>

                    <HeaderManagementHistory
                        data={data}
                        setUserManagementOpen={setUserManagementOpen}
                    />
                </div>

                <div className=' bg-white-100 p-5 rounded-[10px]'>
                    {/* <div className=' flex flex-row'>
            <p
              className={
                tab1 ? `mr-[36px] text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer` :
                  `mr-[36px] text-gray-100 font-roboto text-2xl font-medium cursor-pointer`
              }
              onClick={() => onChangeTab(1)}
            >
              Detail Profile
            </p>
            <p
              className={
                tab2 ? `mr-[36px] text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer ml-2` :
                  `mr-[36px] text-gray-100 font-roboto text-2xl font-medium ml-2 cursor-pointer`
              }
              onClick={() => onChangeTab(2)}
            >
              Operational Hours
            </p>
            <p
              className={
                tab3 ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer ml-2` :
                  `text-gray-100 font-roboto text-2xl font-medium ml-2 cursor-pointer`
              }
              onClick={() => onChangeTab(3)}
            >
              Operational Date
            </p>
          </div> */}
                    {/* {
            tab1 ? ( */}
                    <DetailProfile/>
                    {/* ) :
              tab2 ? (
                <OperationalHours />
              ) :
                tab3 ? (
                  <OperationalDate setOperationalDateData={setOperationalDateData}/>
                ) : null
          } */}

                    <ManagementHistory
                        id={data?.company_profile_id}
                        detail={data}
                        tableName={'company_profile'}
                        userManagementOpen={userManagementOpen}
                        setUserManagementOpen={() => setUserManagementOpen(false)}
                    />
                </div>
                <div className='flex flex-row-reverse gap-[16px] mt-4'>
                    <PrimaryButton text={t("USER_DETAIL:EDIT")} action={_toEdit}/>
                </div>
            </div>
        </>
    );
}

export default DetailCompanyProfile;